import { field, formatUnits, readContract, writeContractAndWait } from "../viem";

import MafiaHospitalAbi from "../../abis/MafiaHospital.json";
import config from "../../config/config";

const address = config.hospitalAddress;
const abi = MafiaHospitalAbi;

export const getCityHospitalInfo = async (cityId: number) => {
  const cityMarketInfo: any = await readContract({
    address,
    abi,
    functionName: "getCityHospitalInfo",
    args: [cityId],
  });

  return {
    price: Number(formatUnits(field(cityMarketInfo, "price", 0), 18)),
    amountLeft: Number(field(cityMarketInfo, "amountLeft", 1)),
    lastUpdateTime: Number(field(cityMarketInfo, "lastUpdateTime", 2)),
  };
};

export const buyHealth = async (
  account: string,
  healthAmount: number,
  message: string,
  signature: string
) => {
  const txData = await writeContractAndWait({
    address,
    abi,
    functionName: "buyHealth",
    args: [healthAmount, JSON.stringify(message), signature],
    account,
    gasMultiplier: 5,
  });

  return txData;
};

export const claimHospitalProfit = async (account: string, cityId: number) => {
  const txData = await writeContractAndWait({
    address,
    abi,
    functionName: "claimProfit",
    args: [cityId],
    account,
  });

  return txData;
};

export const getHealthMarketUpdateInterval = async () => {
  const updateInterval: number = await readContract({
    address,
    abi,
    functionName: "updateInterval",
  });
  return Number(updateInterval);
};

export const getNextHealthBuyTime = async (account: string) => {
  const nextBuyTime: number = await readContract({
    address,
    abi,
    functionName: "nextBuyTime",
    args: [account],
  });
  return Number(nextBuyTime);
};

export const reproduceBlood = async (account: string, cityId: number) => {
  const txData = await writeContractAndWait({
    address,
    abi,
    functionName: "reproduceBlood",
    args: [cityId],
    account,
  });

  return txData;
};